module.exports = __webpack_public_path__ + "static/media/winningSound.9aefd125.wav";